import { render, staticRenderFns } from "./certified.vue?vue&type=template&id=7640fb9a&scoped=true"
import script from "./certified.vue?vue&type=script&lang=js"
export * from "./certified.vue?vue&type=script&lang=js"
import style0 from "@/styles/wap.scss?vue&type=style&index=0&id=7640fb9a&prod&lang=scss&scoped=true&external"
import style1 from "./certified.vue?vue&type=style&index=1&id=7640fb9a&prod&scoped=true&lang=scss"
import style2 from "./certified.vue?vue&type=style&index=2&id=7640fb9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7640fb9a",
  null
  
)

export default component.exports